// =================================================================
// Engine: Sawchuk-Zaske two-level PK (PSD §4.2.9 / TODO Task 2.1)
// =================================================================
import { err, ok } from './types';
const MIN_HOURS_BETWEEN = 0.5;
const LN2 = Math.log(2);
/**
 * Sawchuk-Zaske two-level PK (PSD §4.2.9).
 * kel = ln(level1/level2) / timeBetween; back-extrapolate peak; Vd = dose/peak.
 */
export function sawchukZaske(level1, level2, doseMg, infusionDurationHr, dosingWeightKg) {
    // Order so level1 is earlier
    let first = level1;
    let second = level2;
    if (second.drawOffsetFromInfusionEndMin < first.drawOffsetFromInfusionEndMin) {
        [first, second] = [second, first];
    }
    // Levels during infusion (pre-distribution) → reject
    if (first.drawOffsetFromInfusionEndMin < infusionDurationHr * 60) {
        return err('level-during-infusion', 'Levels drawn during infusion (pre-distribution) cannot be used.');
    }
    if (second.valueMg >= first.valueMg) {
        return err('levels-not-declining', 'Levels are not declining — may be drawn during distribution phase.');
    }
    const timeBetweenHr = (second.drawOffsetFromInfusionEndMin - first.drawOffsetFromInfusionEndMin) / 60;
    if (timeBetweenHr < MIN_HOURS_BETWEEN) {
        return err('levels-too-close', 'Levels drawn < 0.5h apart — unreliable Kel.');
    }
    const kelPerHr = Math.log(first.valueMg / second.valueMg) / timeBetweenHr;
    const timeFromInfusionEndToLevel1Hr = first.drawOffsetFromInfusionEndMin / 60;
    const cPeakExtrapolated = first.valueMg / Math.exp(-kelPerHr * timeFromInfusionEndToLevel1Hr);
    const vdL = doseMg / cPeakExtrapolated;
    const vdLkg = vdL / dosingWeightKg;
    const halfLifeHr = LN2 / kelPerHr;
    const lowConfidence = timeBetweenHr < 1.0;
    return ok({ kelPerHr, halfLifeHr, vdL, vdLkg, lowConfidence });
}
//# sourceMappingURL=sawchukZaske.js.map